import { DrObject, DrObjectType, SupportedRegExType } from "./dr-object";

export class Organization {
    organizationName: string;
    description: string;
    organizationHandle: string;
    role: { handle: string, name: string };

    constructor(value?: Partial<Organization>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class OrganizationViewModel extends DrObject {

    model: Partial<Organization>;

    constructor(value?: Partial<Organization>) {
        super(DrObjectType.ORGANIZATION, SupportedRegExType.ORGANIZATION);

        if (value) {
            this.model = value;
        }
    }
}
